import { useAxios } from "../axiosConfig";

const GeneralPolicyApi = () => {
    const axiosConfig = useAxios();
    const langId = localStorage.getItem("i18nextLngId")
    let lang = langId === '2' ? 'EN' : 'VN'

    const getGeneralPolicyCountry = async () => {
        try {
            const response = await axiosConfig.get(`/management/generalpolicy/getParameters/${lang}/country`);


            return response;
        } catch (error) {
            throw error;
        }
    };

    const getGeneralPolicyUserRole = async () => {
        try {
            const response = await axiosConfig.get(`/management/generalpolicy/getParameters/${lang}/userRole`);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const getGeneralPolicyCompany = async () => {
        try {
            const response = await axiosConfig.get(`/management/generalpolicy/getParameters/${lang}/company`);

            return response;
        } catch (error) {
            throw error;
        }
    };

    return { getGeneralPolicyCountry, getGeneralPolicyUserRole, getGeneralPolicyCompany }
}

export default GeneralPolicyApi
